import styled from "styled-components";
import { Field } from "formik";

export const Heading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Noto Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 150%;
  color: #383838;
  margin-top: ${(props) => props.margin || "0px"};
  background: linear-gradient(
    to bottom,
    #70aee9 0%,
    /* Start color (#70AEE9) at the top (0%) */ #ffffff 100%
      /* End color (#FFFFFF) at the bottom (100%) */
  );
  padding-top: 30px;
  padding-bottom: 10px;
`;

export const OuterContainerStyles = styled.div`
  border-radius: 6px;
  background: #fff;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
  margin-left: 24px;
  margin-right: 24px;
  margin-top: ${(props) => props.marginTop ?? "0px"};
  margin-bottom: ${(props) => props.marginBottom ?? "0px"};
`;
export const Title = styled.p`
  color: #000;
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  padding: 20px 0 0 55px;
`;
export const SearchContainer = styled.div`
  display: flex;
  gap: 20px;
  padding: 20px 0 20px 70px;
  align-items: center;
`;
export const ExistingText = styled.p`
  color: #000;
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  padding: 30px 0 0 35px;
`;
export const SearchContainerTable = styled.div`
  display: flex;
  gap: 20px;
  padding: 20px 0 20px 100px;
  align-items: center;
`;
export const CustomInputField = styled(Field)`
  border-radius: 3px;
  border: 0.5px solid #484848;
  padding: 10px;
`;
